@switch (currentGroupIntervalType()) {
  @case (timeSlotIntervalTypes.Express) {
    <span class="text-b3-s-300">доставка в течение 3-х часов после оформления заказа</span>
  }
  @case (timeSlotIntervalTypes.ExactlyInTime) {
    <sd-exactly-in-time [selectedGroup]="selectedGroup()" [(selectedOption)]="selectedOption"></sd-exactly-in-time>
  }
  @default {
    <!-- todo: если таймслотов больше 15, то отображать в виде дропдауна -->
    @for (option of selectedGroup().options; track option.id) {
      <sd-item-wrapper (click)="onSelectOption(option)" [isActive]="option.id === selectedOption()?.id">
        <span>{{ option.interval.clientInterval.timeFromTo }}</span>
        <span>{{ option.price.total }} ₽</span>
      </sd-item-wrapper>
    }
  }
}
